import Model from "@/app/models/Concerns/Model";
import {AxiosResponse} from "axios";
import Client from "@/app/Http/Client";

export default class FunctionGroup extends Model {
    // @ts-ignore
    public id!: string;
    public name!: string;

    getTable(): string {
        return "function-groups";
    }
}